import { AxiosResponse } from 'axios';

import API from '../Api';
import { NordPoolMargins, NordPoolSpotGraphDatapoint } from '../types/graphs';

export const fetchNordPoolSpotData = async (
  start: string,
  end: string,
  resolution = 'hour',
  impact = false,
): Promise<NordPoolSpotGraphDatapoint[] | false> => {
  try {
    const nordPoolData = await API({
      method: 'get',
      url: `/v1/getNordPoolData/${start}/${end}/${resolution}?impact=${impact}`,
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 404) {
          return false;
        }
      }
    });

    if (!nordPoolData) {
      return false;
    }

    return nordPoolData.data;
  } catch {
    return [];
  }
};

export const fetchNordPoolMargins = async (): Promise<NordPoolMargins> => {
  const nordPoolData: AxiosResponse<NordPoolMargins> = await API({
    method: 'get',
    url: `/v1/getNordPoolMargins/2`,
  });

  return nordPoolData.data;
};
